import { useSelector } from 'react-redux';

/**
 * 自定义钩子，返回一个布尔值数组，表示用户是否具有指定的权限。
 *
 * @param {Array} resources - 要检查权限的资源字符串数组。
 * @returns {Array} 布尔值数组，表示用户是否具有指定的权限。
 * @example
 * const [hasReadPerm, hasWritePerm, hasDeletePerm] = usePerms(['read', 'write', 'delete']);
 */
export default function usePerms(resources = []) {
  // Fetch the permissions from the Redux store.
  const perms = useSelector((state) => state.auth.perms || []);

  /**
   * Map over the resources array and check if the user has the permission for each.
   * Return an array of booleans indicating if the user has the specified permissions.
   */
  return resources.map((resource) => perms.includes(resource));
}
